
import React from 'react';
import { Shield, AlertTriangle, CheckCircle, FileText, ArrowRight } from 'lucide-react';

interface AiPolicyVerificationProps {
  isVerifying: boolean;
  isVerified: boolean;
  comprehensionScore?: number;
  feedback?: string[];
  onVerificationComplete: (success: boolean) => void;
}

const AiPolicyVerification: React.FC<AiPolicyVerificationProps> = ({
  isVerifying,
  isVerified,
  comprehensionScore,
  feedback,
  onVerificationComplete
}) => {
  return (
    <div className="mt-4 p-4 rounded-lg border border-gray-200 bg-gray-50">
      <div className="flex items-start">
        <div className="mr-3 mt-1">
          {isVerifying ? (
            <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center">
              <div className="h-4 w-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
            </div>
          ) : isVerified ? (
            <div className="h-8 w-8 rounded-full bg-green-100 flex items-center justify-center">
              <CheckCircle className="h-5 w-5 text-green-500" />
            </div>
          ) : (
            <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center">
              <FileText className="h-5 w-5 text-blue-500" />
            </div>
          )}
        </div>
        <div>
          <h3 className="font-medium text-gray-900">
            {isVerifying ? 'Analyzing policy agreement...' : isVerified ? 'Policy verification complete' : 'AI Policy Verification'}
          </h3>
          <p className="text-sm text-gray-500">
            {isVerifying 
              ? 'Our AI is analyzing your understanding of our terms and privacy policy.'
              : isVerified 
                ? `Your policy comprehension has been verified with a score of ${comprehensionScore || 'N/A'}/100.`
                : 'Accept our terms and privacy policy to be verified by our AI system.'}
          </p>
          
          {isVerified && feedback && feedback.length > 0 && (
            <div className="mt-2 text-xs text-gray-600 border-t pt-2">
              <p className="font-medium mb-1">AI Feedback:</p>
              <ul className="list-disc pl-4 space-y-1">
                {feedback.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          )}
          
          {isVerified && (
            <div className="flex items-center gap-2 mt-2 text-sm text-blue-600">
              <Shield size={16} />
              <span>Ready to proceed with account creation</span>
              <ArrowRight size={14} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AiPolicyVerification;
